export const getMultilineAddressValidation = (value: boolean = false) => {
  return {
    country: {
      required: value,
    },
    addressLine: {
      required: value,
    },
    addressLine2: {
      required: value,
    },
    city: {
      required: value,
    },
    postalCode: {
      required: value,
    },
    subdivision: {
      required: value,
    },
    streetName: {
      required: value,
    },
    streetNumber: {
      required: value,
    },
  };
};
